import { Box, IconButton, styled } from '@mui/material';
import { EFieldType, IField } from '../../models/form/form';
import { ReactNode, useState } from 'react';
import InputField from './previewFields/InputField';
import TextField from './previewFields/TextField';
import DeleteOutlinedIcon from '@mui/icons-material/Delete';
import BuildOutlinedIcon from '@mui/icons-material/Build';
import SelectField from './previewFields/SelectField';
import ImageUploaderField from './previewFields/ImageUploaderField';
import { theme } from '../../styles/themes/mainTheme';
import RatingField from './previewFields/RatingField';
import EditOnly from '../permissions/EditOnly';

const FormFieldWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    pointer: "pointer",
}));

const FieldOptionsWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));

const FieldWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid',
    borderColor: theme.palette.primary.main,
    width: '90%',
    padding: '1%',
    cursor: 'move'
}));

interface IFormFieldProps {
    deleteField: (position: number) => void;
    editField: (field: IField) => void;
    field: IField;
}

const FormField = ({ field, deleteField, editField }: IFormFieldProps) => {
    const [isFocused, setIsFocused] = useState<boolean>(false);

    const Views: Map<EFieldType, ReactNode> = new Map<EFieldType, ReactNode>([
        [EFieldType.Text, <TextField field={field} />],
        [EFieldType.Input, <InputField field={field} />],
        [EFieldType.Select, <SelectField field={field} />],
        [EFieldType.Image, <ImageUploaderField field={field} />],
        [EFieldType.Rating, <RatingField field={field} />]
    ]);
    return (
        <FormFieldWrapper onMouseEnter={() => setIsFocused(true)} onMouseLeave={() => setIsFocused(false)}>
            <FieldWrapper sx={{ border: !isFocused ? "none" : "" }}>
                {Views.get(field.fieldType)}
            </FieldWrapper>

            {isFocused && (
                <EditOnly>
                    <FieldOptionsWrapper>
                        <IconButton sx={{ color: theme.palette.error.main }} onClick={() => deleteField(field.position)}><DeleteOutlinedIcon /></IconButton>
                        <IconButton onClick={() => editField(field)}><BuildOutlinedIcon /></IconButton>
                    </FieldOptionsWrapper>
                </EditOnly>
            )}
        </FormFieldWrapper>
    );
};

export default FormField;
